<nz-date-picker [nzDisabledDate]="disabledDate" [nzShowToday]="false" [nzDisabled]="!notLoading"
  [nzFormat]="global.companyConfiguration.DateFormat" [(ngModel)]="field.Value"
  [nzDisabled]="field.ReadOnly"
  (ngModelChange)="adjustDateVals(field);fieldsChanged(field.FieldName)">
</nz-date-picker>
<ng-template #tplRender let-current>
  <div class="ant-picker-cell-inner" [class.border]="current.getDate() === 1">
    {{ current.getDate() }}
  </div>
</ng-template>
